import React, { ErrorInfo } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router";
import reportWebVitals from './reportWebVitals';


import './variables.css';
import './topchef.css';
import AppRoutes from 'routes';
import { NotificationProvider } from 'shared/NotificationContext'
import Notifications from 'pages/shared/notifications/Notifications'
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from 'pages/shared/error-fallback/ErrorFallback';
import './i18n';



const root = ReactDOM.createRoot(document.getElementById('root')!);


function logErrorToService(error: any, info: ErrorInfo) {
  console.error("Caught an error:", error, info);
}


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={logErrorToService}>
          <NotificationProvider>
            <AppRoutes />
            <Notifications/>
          </NotificationProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
